export const AccountSplash_style = {
  rootSx: {
    display: 'grid',
    gridTemplateRows: 'minmax(auto, 34%) minmax(auto, 66%)',
    background: '#F3F0FF',
    minHeight: '100vh',
    position: 'relative',
  },
  titleSx: {
    color: '#0E1824',
    fontWeight: '500',
    fontSize: '20px',
    pt: 1,
    textAlign: 'center',
  },
  subtitleSx: {
    fontWeight: '400',
    textAlign: 'center',
    pt: 2.25,
    px: 9,
    color: '#F0F0F0',
  },
  resetSx: {
    textAlign: 'center',
    margin: '0',
    position: 'absolute',
    top: '50%',
    left: '50%',
    width: '100%',
    transform: 'translate(-50%, -50%)',
  },
  avatarSx: {
    width: '100%',
    maxWidth: '100px',
    height: '100px',
    margin: '7px auto',
  },
  backgroundrootSx: {
    width: '100%',
    minHeight: '100vh',
    backgroundRepeat: 'no-repeat',
    backgroundSize: 'cover',
    backgroundPosition: 'center',
  },
  splashSx: {
    width: '100%',
    maxWidth: '350px',
  },
};
